import { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import is from 'is_js';

(window as Window & { global: typeof window }).global = window;

import FalconRoutes from '@/routes';
import 'react-toastify/dist/ReactToastify.css';
import { useAppContext } from '@/Main';
import HelpDrawer from '@/app/common/components/drawers/HelpDrawer';
import AppUpdateBanner from '@/components/common/AppUpdateBanner';
import useAppUpdateAvailable from '@/hooks/useAppUpdateAvailable';
import { ErrorBoundary } from 'react-error-boundary';
import Error500 from './components/errors/Error500';

const App = () => {
  const HTMLClassList = document.getElementsByTagName('html')[0].classList;
  const {
    config: { navbarPosition, isDark }
  } = useAppContext();
  const { updateAvailable, dismissUpdate } = useAppUpdateAvailable();

  useEffect(() => {
    if (is.windows()) {
      HTMLClassList.add('windows');
    }
    if (is.chrome()) {
      HTMLClassList.add('chrome');
    }
    if (is.firefox()) {
      HTMLClassList.add('firefox');
    }
    if (is.safari()) {
      HTMLClassList.add('safari');
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === 'double-top') {
      HTMLClassList.add('double-top-nav-layout');
    }
    return () => HTMLClassList.remove('double-top-nav-layout');
  }, [navbarPosition, HTMLClassList]);

  return (
    <>
      <Router
        basename={import.meta.env.VITE_PUBLIC_URL}
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <ErrorBoundary
          FallbackComponent={Error500}
          onReset={() => {
            // Reset state or log error reporting
          }}
        >
          <HelpDrawer />
          <FalconRoutes />
          <AppUpdateBanner open={updateAvailable} onDismiss={dismissUpdate} />
          <ToastContainer
            style={{ fontSize: '0.875rem' }}
            key={isDark ? 'dark' : 'light'}
            position="top-center"
            theme={isDark ? 'dark' : 'light'}
            rtl
          />
        </ErrorBoundary>
      </Router>
    </>
  );
};

export default App;
